export const normalizeNotifications = (notifications = []) =>
  notifications.map((notification) => ({
    customerEmail:
      notification.customerEmail ||
      notification.email ||
      notification.customer?.email ||
      notification.user?.email ||
      "",
    customerName:
      notification.customerName ||
      notification.customerFullName ||
      notification.name ||
      notification.customer?.name ||
      notification.customer?.fullName ||
      notification.user?.fullName ||
      notification.user?.name ||
      [notification.user?.firstName, notification.user?.lastName]
        .filter(Boolean)
        .join(" ") ||
      "",
    id: notification.id,
    title:
      notification.notiTitle ||
      notification.title ||
      notification.notificationTitle ||
      "Notification",
    body:
      notification.notiBody ||
      notification.body ||
      notification.notificationBody ||
      "",
    isRead: Boolean(notification.isRead),
    createdAt:
      notification.createdAt ||
      notification.updatedAt ||
      notification.notificationDate ||
      "",
    raw: notification,
  }));

export const getUnreadCount = (notifications = []) =>
  notifications.filter((notification) => !notification.isRead).length;

export const getUnreadNotificationIds = (notifications = []) =>
  notifications
    .filter((notification) => !notification.isRead)
    .map((notification) => notification.id);

export const getNewUnreadNotifications = (
  notifications = [],
  seenNotificationIds = new Set()
) =>
  notifications.filter(
    (notification) =>
      !notification.isRead && !seenNotificationIds.has(notification.id)
  );
